import { createStateSelectorHook } from 'src/lib/sweetState';
import { ProjectStore } from 'src/store/project';

const useProjectState = createStateSelectorHook(ProjectStore, ['imageOverlayProperties']);

export const useViewState = () => {
  const { imageOverlayProperties } = useProjectState();

  return {
    imageOverlayProperties,
  };
};
